import Vue from 'vue'
import VueRouter from 'vue-router'
import { hasRoutePermission } from '@/utils/permission'
import { buildPermissionMenus } from '@/utils/menu'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: 'welcome',
        name: 'Welcome',
        component: () => import('@/views/welcome/index.vue'),
        meta: { title: '欢迎页' }
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import(/* webpackChunkName: "Dashboard" */'@/views/dashboard/index.vue'),
        meta: {
          title: '整体看板',
          icon: 'el-icon-s-data',
          permissionCodes: ['dashboard:overall']
        }
      },
      {
        path: 'device',
        name: 'Device',
        component: () => import(/* webpackChunkName: "Device" */'@/views/device/index.vue'),
        meta: {
          title: '设备管理',
          icon: 'el-icon-s-tools',
          permissionModule: 'device'
        }
      },
      {
        path: 'qc-record',
        name: 'QcRecord',
        component: () => import(/* webpackChunkName: "QcRecord" */'@/views/qc-record/index.vue'),
        meta: {
          title: '质检记录',
          icon: 'el-icon-document-checked',
          permissionModule: 'device-inspections'
        }
      },
      {
        path: 'user',
        name: 'User',
        component: () => import(/* webpackChunkName: "User" */'@/views/user/index.vue'),
        meta: {
          title: '用户管理',
          icon: 'el-icon-user',
          permissionModule: 'user'
        }
      },
      {
        path: 'invite-partner',
        name: 'InvitePartner',
        component: () => import(/* webpackChunkName: "InvitePartner" */'@/views/invite-partner/index.vue'),
        meta: {
          title: '合伙人管理',
          icon: 'el-icon-share',
          permissionModule: 'partners'
        }
      },
      {
        path: 'order',
        name: 'Order',
        component: () => import(/* webpackChunkName: "Order" */'@/views/order/index.vue'),
        meta: {
          title: '订单管理',
          icon: 'el-icon-s-order',
          permissionCodes: ['order', 'order:menu', 'order:page']
        }
      },
      {
        path: 'operator-order',
        name: 'OperatorOrder',
        component: () => import(/* webpackChunkName: "OperatorOrder" */'@/views/operator-order/index.vue'),
        meta: {
          title: '运营商订单管理',
          icon: 'el-icon-s-order',
          permissionCodes: ['order:biz-operator', 'order:biz-operator:page']
        }
      },
      {
        path: 'role',
        name: 'Role',
        component: () => import(/* webpackChunkName: "Role" */'@/views/role/index.vue'),
        meta: {
          title: '角色管理',
          icon: 'el-icon-s-finance',
          permissionModule: 'role'
        }
      },
      // 暂时不要了 其实后面都用账户管理页面了
      // {
      //   path: 'limits',
      //   name: 'Limits',
      //   component: () => import('@/views/limits/index.vue'),
      //   meta: { title: '权限管理', icon: 'el-icon-s-check' }
      // },
      {
        path: 'operation',
        name: 'Operation',
        component: () => import(/* webpackChunkName: "Operation" */'@/views/operation/index.vue'),
        meta: {
          title: '运营配置',
          icon: 'el-icon-s-marketing',
          permissionCodes: ['package', 'pricing-rules', 'pricing-rules:list']
        }
      },
      {
        path: 'maintenance',
        name: 'Maintenance',
        component: () => import(/* webpackChunkName: "Maintenance" */'@/views/maintenance/index.vue'),
        meta: {
          title: '运维管理',
          icon: 'el-icon-s-tools',
          permissionModule: 'ops-devices'
        }
      },
      {
        path: 'account',
        name: 'Account',
        component: () => import(/* webpackChunkName: "Account" */'@/views/account/index.vue'),
        meta: {
          title: '账户管理',
          icon: 'el-icon-user-solid',
          permissionModule: 'admin-users'
        }
      },
      {
        path: 'enterprise',
        name: 'Enterprise',
        component: () => import(/* webpackChunkName: "Enterprise" */'@/views/enterprise/index.vue'),
        meta: {
          title: '企业管理',
          icon: 'el-icon-office-building',
          permissionModule: 'company'
        }
      },
      {
        path: 'operator',
        name: 'Operator',
        component: () => import(/* webpackChunkName: "Operator" */'@/views/operator/index.vue'),
        meta: {
          title: '一级运营商列表',
          icon: 'el-icon-s-custom',
          permissionCode: 'biz-operator:one'
        }
      },
      {
        path: 'operator-level2',
        name: 'OperatorLevel2',
        component: () => import(/* webpackChunkName: "OperatorLevel2" */'@/views/operator/level2.vue'),
        meta: {
          title: '二级运营商列表',
          icon: 'el-icon-s-custom',
          permissionCode: 'biz-operator:second'
        }
      },
      {
        path: 'operator-bill',
        name: 'OperatorBill',
        component: () => import(/* webpackChunkName: "OperatorBill" */'@/views/operator-bill/index.vue'),
        meta: {
          title: '运营商对账管理',
          icon: 'el-icon-s-finance',
          permissionCodes: ['biz-operator:bill', 'bill:page']
        }
      },
      {
        path: 'site',
        name: 'Site',
        component: () => import(/* webpackChunkName: "Site" */'@/views/site/index.vue'),
        meta: {
          title: '站点管理',
          icon: 'el-icon-location-outline',
          permissionModule: 'site'
        }
      },
      {
        path: 'oper-log',
        name: 'OperLog',
        component: () => import(/* webpackChunkName: "OperLog" */'@/views/oper-log/index.vue'),
        meta: {
          title: '操作日志',
          icon: 'el-icon-document',
          // 菜单节点是 sys-opr-log，接口权限是 oper-logs:*
          permissionCodes: ['sys-opr-log', 'oper-logs', 'oper-logs:page']
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 跳转被守卫拦截时会 reject，这里吞掉中断异常，避免控制台报未捕获错误
const originalPush = router.push.bind(router)
router.push = function (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush(location, onResolve, onReject)
  }
  return originalPush(location).catch((error) => {
    if (VueRouter.isNavigationFailure && VueRouter.isNavigationFailure(error)) {
      return error
    }
    return Promise.reject(error)
  })
}

function getStoredUserInfo() {
  try {
    return JSON.parse(localStorage.getItem('userInfo') || '{}')
  } catch (error) {
    return {}
  }
}

function getFirstMenuPath(userInfo) {
  const menus = buildPermissionMenus((userInfo && userInfo.permissions) || [], userInfo)
  for (const menu of menus) {
    if (menu.children && menu.children.length) return menu.children[0].path
    if (menu.path) return menu.path
  }
  return ''
}

function getHomePath(userInfo) {
  const info = userInfo || getStoredUserInfo()
  if (hasRoutePermission(info, { permissionCodes: ['dashboard:overall'] })) {
    return '/dashboard'
  }
  return getFirstMenuPath(info) || '/welcome'
}

function getDeniedMessage(route) {
  if (route.meta && route.meta.deniedMessage) return route.meta.deniedMessage
  const title = route.meta && (route.meta.menuTitle || route.meta.title)
  return title ? `无${title}查看权限` : '无权限访问'
}

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' - 扫赢管理系统'
  }
  
  const token = localStorage.getItem('token')
  
  if (to.path === '/login' && token) {
    next(getHomePath())
    return
  }
  
  if (to.path !== '/login' && !token) {
    next('/login')
    return
  }
  
  if (to.path !== '/login') {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')

    if (to.path === '/') {
      next(getHomePath(userInfo))
      return
    }

    if (!hasRoutePermission(userInfo, to.meta)) {
      Vue.prototype.$message.warning(getDeniedMessage(to))
      if (!from.name) {
        const firstPath = getFirstMenuPath(userInfo)
        next(firstPath && firstPath !== to.path ? firstPath : '/welcome')
      } else if (to.path !== '/welcome') {
        next('/welcome')
      } else {
        next(false)
      }
      return
    }
  }
  
  next()
})

export default router